import { ICategory } from 'repositories/category/CategoryRepository';
import { create } from 'zustand';

/**

  const [list, setList] = useState<ICtgryTree[]>([]);
  const [root, setRoot] = useState<ICtgryTree>(new CtgryTree());
  const [dict, setDict] = useState<Record<number, ICtgryTree>>({});
 */

export interface ICategoryDlCenter extends ICategory {
  lowerModels: string[];
  models: string[];
}

export interface ICtgryTree {
  parent: ICtgryTree;
  self: ICategoryDlCenter;
  childs: ICtgryTree[];
  menuOpen: boolean;
}

export class CtgryTree implements ICtgryTree {
  menuOpen: boolean = false;
  parent: ICtgryTree;
  self: ICategoryDlCenter;
  childs: ICtgryTree[] = [];
}

export type ZstdProdCtgry = {
  ctgryProdList: ICtgryTree[];
  setCtgryProdList: (a: ICtgryTree[]) => void;
  ctgryProdDict: Record<number, ICtgryTree>;
  setCtgryProdDict: (v: Record<number, ICtgryTree>) => void;
  ctgryProdRoot: ICtgryTree;
  setCtgryProdRoot: (v: ICtgryTree) => void;
};

export const useZstdProdCtgry = create<ZstdProdCtgry>((set) => ({
  ctgryProdList: [],
  setCtgryProdList: (a: ICtgryTree[]) => {
    set({ ctgryProdList: a });
  },
  ctgryProdDict: {},
  setCtgryProdDict: (v: Record<number, ICtgryTree>) => {
    set({ ctgryProdDict: v });
  },
  ctgryProdRoot: new CtgryTree(),
  setCtgryProdRoot: (v: ICtgryTree) => {
    set({ ctgryProdRoot: v });
  },
}));
